__turbopack_context__.v({
  "divider": "_9q77NW_divider",
});
